import { render, staticRenderFns } from "./GarantiaContratoListForm.vue?vue&type=template&id=20581511"
import script from "./GarantiaContratoListForm.vue?vue&type=script&lang=js"
export * from "./GarantiaContratoListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports